import React, {
  useState,
  useEffect,
  useRef
} from 'react';
import moment from 'moment';

import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import {
  collection,
  getDocs,
  query,
  where,
  addDoc, updateDoc,
  doc,
  orderBy,
  onSnapshot,
  serverTimestamp
} from "firebase/firestore";
import './Forum.css';

import { Footer } from '../../components/footer/footer';
import Googleadshorizontal from '../../components/google-AdSense/Googleadshorizontal';
import Navbarr from '../../components/header/Navbarr';
import ScrollButton from '../../components/scrollbutton/ScrollButton';
import Subheader from '../../components/subheader/Subheader';
import { ModalCustom } from '../../components/modalcustom/modalcustom';
import profileimg from "../../assets/large profileicon.svg";
import { imgpath, imgpathapp } from '../../Config/config';

import { db } from '../../Config/firebase';
import { Errormsg } from '../../components/tostifymsg/Errrormsg';
import { Link } from 'react-router-dom';

function Forum() {
  const loginuserinfo = useSelector((state) => state.loginuserinfo);

  const userprofileimage = Cookies.get("userprofileimage");
  const email = Cookies.get("email");
  const userId = Cookies.get("id");
  const username = Cookies.get("username");
  const firebaseUseruid = Cookies.get('firebaseuid');
  
  const [showModal, setShowModal] = useState(false);
  const [tags, setTags] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const [tagsAll, setTagsAll] = useState([]);
  const [tagSelectedFilter, settagSelectedFilter] = useState('');
  const [forum, setForum] = useState([]);


  const [forumData, setForumData] = useState({
    title: "",
    tag: "",
    description: ""
  });

  useEffect(() => {
    const fetchTags = async () => {
      if (forumData.tag.trim() === "") {
        setSuggestions([]);
        setShowDropdown(false);
        return;
      }

      const tagsRef = collection(db, "Tags");
      const q = query(
        tagsRef,
        where("name", ">=", forumData.tag),
        where("name", "<=", forumData.tag + "\uf8ff")
      );

      const querySnapshot = await getDocs(q);
      const results = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setSuggestions(results);
      setShowDropdown(results.length > 0);
    };

    fetchTags();
  }, [forumData.tag]);

  useEffect(() => {
    const q = query(
      collection(db, 'Tags'),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const tagsAll = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setTagsAll([
        {
          id: 'all',
          name: 'All',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        },
        ...tagsAll,
      ]);
      settagSelectedFilter('all');
    });

    return () => unsubscribe();
  }, []);
  
  useEffect(() => {
    let q;

    if (tagSelectedFilter && tagSelectedFilter !== "all") {
      q = query(
        collection(db, "Posts"),
        where("tagsIds", "array-contains", tagSelectedFilter),
        orderBy("createdAt", "desc")
      );
    } else {
      q = query(
        collection(db, "Posts"),
        orderBy("createdAt", "desc")
      );
    }

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const posts = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setForum([ ...posts ]);
    });

    return () => unsubscribe();
  }, [tagSelectedFilter]);

  const handleSelectTag = (tagId, tagName) => {
    if (tags.some(tag => tag.id === tagId || tag.name === tagName)) return;

    setTags([...tags, {
      id: tagId,
      name: tagName
    }]);
    setShowDropdown(false);
    setForumData({ ...forumData, tag: '' })
  };

  const handlerRemoveTag = (tagIdToRemove) => {
    setTags(tags.filter(tag => tag.id !== tagIdToRemove));
  }

  const handlerTags = () => {
    if (forumData.tag.trim() !== "") {
      setTags([...tags, {
        id: Date.now(),
        isNew: true,
        name: forumData.tag.trim()
      }]);
     
      setForumData({ ...forumData, tag: "" });
    }
  }

  const handleSubmit = async () => {
    try {
      if (forumData.title.trim() === "" || forumData.description.trim() === "") {
        throw new Error("Title and Description are required.");
        return;
      }

      if (tags.length === 0) {
        throw new Error("Please add at least one tag.");
        return;
      }

      const newTagsWithIds = [];
      const filteredTagsNews = tags.filter(tag => tag.isNew);
      const filteredTags = tags.filter(tag => !tag.isNew);
      
      if (filteredTagsNews.length > 0) {
        for (const tagNew of filteredTagsNews) {
          const docRef = await addDoc(collection(db, "Tags"), {
            name: tagNew.name,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp()
          });

          await updateDoc(docRef, { id: docRef.id });

          newTagsWithIds.push({
            id: docRef.id,
            name: tagNew.name,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          });
        }
      }

      if(filteredTags.length > 0) {
        newTagsWithIds.push(...filteredTags);
      }

      let imageProfileUrl = `${imgpathapp}` + (
        typeof userprofileimage === 'undefined' || 
        userprofileimage === 'undefined' || 
        userprofileimage === null 
        ? `${profileimg}` : 
          `${userprofileimage}`);

      const dateEntity = {
        commentsCount: 0,
        createdAt: serverTimestamp(),
        description: forumData.description,
        email: email,
        idUser: firebaseUseruid,
        idUserGaffer: firebaseUseruid,
        likes: 0,
        reportsIds: [],
        tags: newTagsWithIds,
        tagsIds: newTagsWithIds.map(tag => tag.id),
        title: forumData.title,
        updatedAt: serverTimestamp(),
        urlProfile: imageProfileUrl,
        username: username
      };

      const docRefPost = await addDoc(collection(db, "Posts"), dateEntity);

      await updateDoc(docRefPost, { id: docRefPost.id });

      setForumData({
        title: "",
        tag: "",
        description: ""
      });
      setTags([]);
      setShowModal(false);
    } catch (error) {
      console.error("❌ Error submitting forum:", error);

      Errormsg(error.message);
    }
  }

  return (
    <div>
      <Navbarr/>

      <div className="after-nav-dsubheader containers con_div">
        <Googleadshorizontal props="mt-2 mb-2 text-center"/>
        <Subheader />
				
				<div className='h-100 min-vh-100'>
          <h1 className='text-center mt-5 text-white fw-bold'>Forum</h1>

          <div className='d-flex flex-column justify-content-center align-items-center mt-4'>
            <div class="input-group search-box mb-4">
              <input type="text" placeholder="Search" value="" name='search' />
              <span>
                <i class="fa fa-search"></i>
              </span>
            </div>

            <div className="container justify-content-center align-items-center d-flex">
              <div className='action-forum'>
                <div className='d-flex align-items-center align-content-center'>
                  <div className="avatar">
                    <img
                      src={loginuserinfo?.userprofileimage == undefined
                        ? imgpath + userprofileimage
                        : imgpath + loginuserinfo?.userprofileimage
                      }
                      className="profileicon"
                      href="javascript:void(0);"
                      alt="proimg"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = profileimg;
                      }}
                    />
                  </div>

                  <div>
                    <p className='action-forum-text mb-0'>What's on your mind?</p>
                  </div>
                </div>

                <span className='icon me-0' onClick={() => setShowModal(true)}>
                  <i class="fa fa-send"></i>
                </span>

              </div>
            </div>

            <div className="container justify-content-center align-items-center d-flex">
              <div className='d-block mt-4'>
                {tagsAll.map((tag) => (
                  <span key={tag.id} className={`tag-badge me-2 mb-2 ${tagSelectedFilter === tag.id ? 'active' : ''}`} onClick={() => settagSelectedFilter(tag.id)}>
                    {tag.name}
                  </span>
                ))}
              </div>
            </div>


            <div className='container mt-4 mb-5'>
              {forum.length === 0 ? (
                <p className='text-center text-white'>No forum posts available.</p>
              ) : (
                forum.map((post) => (
                  <Link to={`/Forum/${post.id}`} key={post.id} className='text-decoration-none'>
                    <div className="forum-post p-3 mb-4 rounded">
                      <h3 className='text-white'>{post.title}</h3>
                      <div className='mt-1'>
                        {post.tags && post.tags.map((tag) => (
                          <span key={tag.id} className="tag-badge me-2 mb-1 bg-primary">
                            {tag.name}
                          </span>
                        ))}
                      </div>
                      
                      <p className='text-white p-0 m-0'>{post.description}</p>
                      
                      <div className='mt-3 text-start border-top border-top-custom pt-3'>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div className='d-flex align-items-center'>
                            <img
                              src={post.urlProfile || profileimg}
                              className="profileicon-sm me-2"
                              href="javascript:void(0);"
                              alt="proimg"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = profileimg;
                              }}
                            />
                            
                            <div className='text-white'>
                              <p className='m-0'>
                                <small>{post.username || 'Unknown'}</small>
                              </p>
                              <p className='m-0'>
                                <small>{moment.tz(post?.createdAt?.toDate(), "UTC").fromNow()}</small>
                              </p>
                            </div>
                          </div>

                          <div>
                            <span className='icon icon-custom-posts ms-0 me-0'>
                              <small><i class="fa fa-comments"></i> <span className='text-white'>{post.commentsCount || 0}</span></small>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))
              )}
            </div>


          </div>
        </div>
      </div>

      <ModalCustom
        modalCustom={showModal}
        setModalCustom={setShowModal}
        title={`ADD NEW FORUM`}
      >
        <div>
          <div className='row'>
            <div className="col-md-12">
              <div className="form-group">
                <label className='mb-2 text-white'>Choose a Title</label>
                <input
                  type="text"
                  className="form-control custom-form-control"
                  placeholder="Choose a Title"
                  value={forumData.title}
                  onChange={(e) => setForumData({ ...forumData, title: e.target.value })}
                />
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <div className="form-group">
                <label className='mb-2 text-white'>Add tags</label>
                <input
                  type="text"
                  className="form-control custom-form-control"
                  placeholder="Add Tags"
                  value={forumData.tag}
                  onChange={(e) => setForumData({ ...forumData, tag: e.target.value })}
                />

                {showDropdown && (
                  <ul
                    className="absolute z-10 border border-gray-300 rounded-md mt-1 w-full max-h-48 overflow-auto shadow-lg"
                    style={{ listStyleType: "none", padding: 0 }}
                  >
                    {suggestions.map((tag) => (
                      <li
                        key={tag.id}
                        onClick={() => handleSelectTag(tag.id, tag.name)}
                        className="px-3 py-2 cursor-pointer hover:bg-gray-100 cursor-pointer"
                      >
                        {tag.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className='mt-2 text-end'>
                <button 
                  type='button'
                  className='border-0 btn-add-tags'
                  onClick={handlerTags}
                >
                  Add new tag
                </button>
              </div>
            </div>
            <div className="col-md-12 mt-2">
              <div className="form-group">
                <label className='mb-2 text-white'>Write your forum</label>
                <textarea
                  className="form-control custom-form-control"
                  rows="4"
                  placeholder="Write something..."
                  value={forumData.description}
                  onChange={(e) => setForumData({ ...forumData, description: e.target.value })}
                ></textarea>
              </div>
            </div>
          </div>

          <div className='mt-3'>
            {tags.map((tag, index) => (
              <span key={index} className="tag-badge me-2 mb-2 cursor-pointer hover:bg-gray-600" onClick={() => handlerRemoveTag(tag.id)}>
                {tag.name}
              </span>
            ))}
          </div>
          
          
          <div className="comment-btn-group mt-4 d-flex justify-content-end">
            <button className="btn text-white clear-button btn-transparent" onClick={() => {
              setShowModal(false);
            }}>Cancel</button>
            <button 
              className={`btn btn-submit-report`} 
              onClick={handleSubmit}
            >Submit Report</button>
          </div>
        </div>
      </ModalCustom>

      <Footer />
      <ScrollButton />
    </div>
  );
}

export default Forum;